import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AuthContext } from "context";
import { useStripeAccount } from "hooks/stripe";
import Form, { Mode } from "../Form";
import { ROUTES } from "routes";
import { Loader } from "ui/Loader";

const ServiceAddPage: React.FC = () => {
    const { account } = useContext(AuthContext);
    const { data, isLoading } = useStripeAccount(account?.resources?.provider[0].stripe_id);

    if (isLoading && !data) {
        return <Loader />;
    }

    return (
        <div className="space-y-6">
            <Link
                to={ROUTES.MY_SERVICES}
                className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-primary"
            >
                <ArrowLeft className="h-4 w-4" strokeWidth={2.25} />
                Retour à mes services
            </Link>

            <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
                <header className="border-b border-gray-100 pb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Ajouter un service</h2>
                    <p className="mt-1 text-sm text-slate-500">
                        Choisissez une catégorie et renseignez les détails de votre prestation.
                    </p>
                </header>

                <div className="service-form-profile mt-8">
                    <Form mode={Mode.ADD} />
                </div>
            </div>
        </div>
    );
};

export default ServiceAddPage;
